module.exports = "/assets/e2dba6d2566aeb00cec00e3c0b20e236.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/QZ.png
// module id = 2892
// module chunks = 0